import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { payrollDetailAction, getNJCertifiedReport } from "../../store/actions/";
import orderBy from "lodash/orderBy";
import Select from "react-select";
import { subYears, format } from "date-fns";
import Loader from '../../components/loader';

const NJCertifiedPayroll = (props) => {
    const [loading, setLoading] = useState(true);
    const [payrollOptions, setPayrollOptions] = useState([]);
    const [selectedPayroll, setSelectedPayroll] = useState(undefined);
    const [displayPayrollSearch, setDisplayPayrollSearch] = useState(false);
    const [zipUrl, setZipUrl] = useState(undefined);

    useEffect(() => {
        const fetchLastPayrolls = async () => {
            let startDate = format(subYears(new Date(), 3), "MM-dd-yyyy");
            await props.payrollDetailAction(props.UserReducer.company, { startDate, payrollType: { $in: ["Regular", "Historical"] } });
            setPayrollOptions(orderBy(props.PayrollReducer?.reduce((memo, payroll) => {
                memo.push({
                    label: payroll.payrollName,
                    value: payroll.payrollSystemId,
                    date: payroll.payPeriodEnd
                });
                return memo;
            }, []),
                elem => Date.parse(elem.date), "desc"));
            setSelectedPayroll(payrollOptions[0]);
            setLoading(false);
        };

        fetchLastPayrolls();
    }, [props.PayrollReducer.length]);


    function handleSelect(selectedOption) {
        setSelectedPayroll(selectedOption);
    }


    async function runReport(company, selectedPayroll) {
        setLoading(true);
        let res = await getNJCertifiedReport(company, selectedPayroll.value);
        const url = window.URL.createObjectURL(new Blob([res.data]), { type: 'application/zip' });
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `nj_certified_payroll_${selectedPayroll.label}.zip`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoading(false);
    };

    return (
        <div className="df ffc wp_report_page" style={{ height: "100%" }}>
            <div className="df download_actns">
                <div className="mla"></div>
            </div>
            {!loading ? (
                <div className="df filters_wrpr mb-5" >
                    <div className='ps-1' style={{ height: "38px", width: '250px', padding: '5px' }}>
                        <Select
                            placeholder={displayPayrollSearch ? "Start typing to search payrolls" : ""}
                            options={payrollOptions}
                            value={selectedPayroll}
                            onChange={handleSelect}
                            onMenuClose={() => setDisplayPayrollSearch(false)}
                            onMenuOpen={() => setDisplayPayrollSearch(true)}
                        >
                        </Select>
                    </div>
                    <div className="df mla">
                        <button
                            className="ttuc fs12 primary"
                            disabled={!selectedPayroll}
                            onClick={() => {
                                runReport(props.UserReducer.company, selectedPayroll);
                            }}
                        >
                            Run
                        </button>
                    </div>
                </div>

            ) : (

                <div style={{ textAlign: "center", top: '138px' }}>
                    <h3>Preparing your report...</h3>
                    <h4>Please wait...</h4>
                    <div className="ec_setup_contact df acc loading">
                        <Loader></Loader>
                    </div>
                </div>

            )}
            {!loading && zipUrl && <object data={zipUrl} width="100%" height="100%"></object>}
            {!loading && !zipUrl && <div className="df acc table_wrpr">
                <p style={{ fontSize: "24px", marginBottom: "150px" }}>
                    Please click run to generate the report
                </p>
            </div>}
        </div>
    );
};

const mapStateToProps = ({ UserReducer, PayrollReducer, }) => {
    return { UserReducer, PayrollReducer, }
};

export default connect(mapStateToProps, {
    payrollDetailAction
})(NJCertifiedPayroll);

